module.exports = __webpack_public_path__ + "img/6.3b999e72.webp";